import * as React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { useHistory } from 'react-router';
import {
  updateUserInfo,
  userInfoSelector,
  clearRequestError,
  userErrorsSelector,
} from '../redux/ducks/userAuth';
import UserAccountForm from '../forms/UserAccountForm';
import DashboardLayout from '../layouts/DashboardLayout';
import useUserRole from '../hooks/useUserRole';
import { ROUTES } from '../modules/clientModule/components/Routes/ClientRoutes';

const UserAccountPage = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(userInfoSelector);
  const userErrors = useSelector(userErrorsSelector);
  const { isClient } = useUserRole();
  const history = useHistory();
  React.useEffect(() => {
    dispatch(clearRequestError());
    if (isClient) {
      history.push(ROUTES.ACCOUNT);
    }

      // setAccountUrl(ROUTES.ACCOUNT);
      // accountUrl.current = ROUTES.ACCOUNT;
      const x = userInfo;
  }, []);

  const handleOnSettingsChange = formValues => {
    dispatch(updateUserInfo(formValues));
  };

  return (
    <DashboardLayout>
      <PageWrapper>
        <UserAccountForm
          initialValues={userInfo}
          initialErrors={userErrors as any}
          onSubmit={handleOnSettingsChange}
        />
      </PageWrapper>
    </DashboardLayout>
  );
};

const PageWrapper = styled.div`
  padding: 24px;
  box-sizing: border-box;
  width: 100%;

  @media only screen and (max-width: 840px) {
    padding: 14px;
  }

  @media only screen and (max-width: 540px) {
    padding: 10px;
  }
`;

export default UserAccountPage;
